import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const steps = [
    { num: "01", title: "Book Your Visit", desc: "Choose a time that suits you through the appointment form or a quick call." },
    { num: "02", title: "Consult With the Dentist", desc: "Share your concerns and get a clear, honest assessment of your oral health." },
    { num: "03", title: "Receive Your Treatment Guidance", desc: "Leave with a personalized plan and straightforward next steps." },
];

export const Process = () => (
    <section data-testid="process-section" className="bg-mist py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <SectionHeading
                number="05"
                eyebrow="The Process"
                title="Three Simple Steps to"
                accent="Better Oral Health"
            />
            <div className="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
                <div aria-hidden="true" className="absolute left-0 right-0 top-10 hidden border-t-2 border-dashed border-teal-600/25 md:block" />
                {steps.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.15} className="relative">
                        <div data-testid={`process-step-${i}`} className="flex flex-col items-start">
                            <span className="relative z-10 grid h-20 w-20 place-items-center rounded-full border-4 border-mist bg-ink font-display text-2xl italic text-teal-300 shadow-lg">
                                {s.num}
                            </span>
                            <h3 className="mt-6 font-display text-2xl text-ink">{s.title}</h3>
                            <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">{s.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
